"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("./css"));

var _getDataName = _interopRequireDefault(require("./getDataName"));

var _utils = require("../../utils");

var _media = _interopRequireDefault(require("../../media"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject43() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getGridColumns = function getGridColumns(theme) {
  if (!theme.styledBootstrapGrid) {
    return 12;
  }

  return theme.styledBootstrapGrid.getGridColumns();
};

var _default = _styledComponents.default.div.attrs(function (props) {
  return {
    'data-name': (0, _getDataName.default)(props)
  };
})(_templateObject(), function (p) {
  if (!p.theme || !p.theme.styledBootstrapGrid || !p.theme.styledBootstrapGrid.getColPadding) {
    return 15;
  }

  return p.theme.styledBootstrapGrid.getColPadding();
}, function (p) {
  if (!p.theme || !p.theme.styledBootstrapGrid || !p.theme.styledBootstrapGrid.getColPadding) {
    return 15;
  }

  return p.theme.styledBootstrapGrid.getColPadding();
}, function (p) {
  return p.noGutter && _css.default.noGutter;
}, function (p) {
  return p.col && _css.default.col(p.col, getGridColumns(p.theme));
}, function (p) {
  return typeof p.offset !== 'undefined' && _css.default.offset(p.offset, getGridColumns(p.theme));
}, function (p) {
  return p.auto && _css.default.col('auto', 0);
}, function (p) {
  return p.alignSelf && _css.default.alignSelf[p.alignSelf];
}, function (p) {
  return p.order && _css.default.order(p.order);
}, function (p) {
  return p.xs && _media.default.xs(_templateObject2(), _css.default.col(p.xs, getGridColumns(p.theme)));
}, function (p) {
  return typeof p.xsOffset !== 'undefined' && (0, _utils.isNumber)(p.xsOffset) && _media.default.xs(_templateObject3(), _css.default.offset(p.xsOffset, getGridColumns(p.theme)));
}, function (p) {
  return p.xsAuto && _media.default.xs(_templateObject4(), _css.default.col('auto', 0));
}, function (p) {
  return p.xsAlignSelf && _media.default.xs(_templateObject5(), _css.default.alignSelf[p.xsAlignSelf]);
}, function (p) {
  return p.xsOrder && _media.default.xs(_templateObject6(), _css.default.order(p.xsOrder));
}, function (p) {
  return p.hiddenXsDown && _media.default.max.xs(_templateObject7(), _css.default.display.none);
}, function (p) {
  return p.hiddenXsUp && _media.default.min.xs(_templateObject8(), _css.default.display.none);
}, function (p) {
  return p.sm && _media.default.sm(_templateObject9(), _css.default.col(p.sm, getGridColumns(p.theme)));
}, function (p) {
  return typeof p.smOffset !== 'undefined' && (0, _utils.isNumber)(p.smOffset) && _media.default.sm(_templateObject10(), _css.default.offset(p.smOffset, getGridColumns(p.theme)));
}, function (p) {
  return p.smAuto && _media.default.sm(_templateObject11(), _css.default.col('auto', 0));
}, function (p) {
  return p.smAlignSelf && _media.default.sm(_templateObject12(), _css.default.alignSelf[p.smAlignSelf]);
}, function (p) {
  return p.smOrder && _media.default.sm(_templateObject13(), _css.default.order(p.smOrder));
}, function (p) {
  return p.hiddenSmDown && _media.default.max.sm(_templateObject14(), _css.default.display.none);
}, function (p) {
  return p.hiddenSmUp && _media.default.min.sm(_templateObject15(), _css.default.display.none);
}, function (p) {
  return p.md && _media.default.md(_templateObject16(), _css.default.col(p.md, getGridColumns(p.theme)));
}, function (p) {
  return typeof p.mdOffset !== 'undefined' && (0, _utils.isNumber)(p.mdOffset) && _media.default.md(_templateObject17(), _css.default.offset(p.mdOffset, getGridColumns(p.theme)));
}, function (p) {
  return p.mdAuto && _media.default.md(_templateObject18(), _css.default.col('auto'));
}, function (p) {
  return p.mdAlignSelf && _media.default.md(_templateObject19(), _css.default.alignSelf[p.mdAlignSelf]);
}, function (p) {
  return p.mdOrder && _media.default.md(_templateObject20(), _css.default.order(p.mdOrder));
}, function (p) {
  return p.hiddenMdDown && _media.default.max.md(_templateObject21(), _css.default.display.none);
}, function (p) {
  return p.hiddenMdUp && _media.default.min.md(_templateObject22(), _css.default.display.none);
}, function (p) {
  return p.lg && _media.default.lg(_templateObject23(), _css.default.col(p.lg, getGridColumns(p.theme)));
}, function (p) {
  return typeof p.lgOffset !== 'undefined' && (0, _utils.isNumber)(p.lgOffset) && _media.default.lg(_templateObject24(), _css.default.offset(p.lgOffset, getGridColumns(p.theme)));
}, function (p) {
  return p.lgAuto && _media.default.lg(_templateObject25(), _css.default.col('auto'));
}, function (p) {
  return p.lgAlignSelf && _media.default.lg(_templateObject26(), _css.default.alignSelf[p.lgAlignSelf]);
}, function (p) {
  return p.lgOrder && _media.default.lg(_templateObject27(), _css.default.order(p.lgOrder));
}, function (p) {
  return p.hiddenLgDown && _media.default.max.lg(_templateObject28(), _css.default.display.none);
}, function (p) {
  return p.hiddenLgUp && _media.default.min.lg(_templateObject29(), _css.default.display.none);
}, function (p) {
  return p.xl && _media.default.xl(_templateObject30(), _css.default.col(p.xl, getGridColumns(p.theme)));
}, function (p) {
  return typeof p.xlOffset !== 'undefined' && (0, _utils.isNumber)(p.xlOffset) && _media.default.xl(_templateObject31(), _css.default.offset(p.xlOffset, getGridColumns(p.theme)));
}, function (p) {
  return p.xlAuto && _media.default.xl(_templateObject32(), _css.default.col('auto'));
}, function (p) {
  return p.xlAlignSelf && _media.default.xl(_templateObject33(), _css.default.alignSelf[p.xlAlignSelf]);
}, function (p) {
  return p.xlOrder && _media.default.xl(_templateObject34(), _css.default.order(p.xlOrder));
}, function (p) {
  return p.hiddenXlDown && _media.default.max.xl(_templateObject35(), _css.default.display.none);
}, function (p) {
  return p.hiddenXlUp && _media.default.min.xl(_templateObject36(), _css.default.display.none);
}, function (p) {
  return p.xxl && _media.default.xxl(_templateObject37(), _css.default.col(p.xxl, getGridColumns(p.theme)));
}, function (p) {
  return typeof p.xxlOffset !== 'undefined' && (0, _utils.isNumber)(p.xxlOffset) && _media.default.xxl(_templateObject38(), _css.default.offset(p.xxlOffset, getGridColumns(p.theme)));
}, function (p) {
  return p.xxlAuto && _media.default.xxl(_templateObject39(), _css.default.col('auto'));
}, function (p) {
  return p.xxlAlignSelf && _media.default.xxl(_templateObject40(), _css.default.alignSelf[p.xxlAlignSelf]);
}, function (p) {
  return p.xxlOrder && _media.default.xxl(_templateObject41(), _css.default.order(p.xxlOrder));
}, function (p) {
  return p.hiddenXxlDown && _media.default.max.xxl(_templateObject42(), _css.default.display.none);
}, function (p) {
  return p.hiddenXxlUp && _media.default.min.xxl(_templateObject43(), _css.default.display.none);
});

exports.default = _default;